function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { LinkElement } from '@els/els-react--link-element';
import { Logo } from '@els/els-react--logo';
import { ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import throttle from 'lodash.throttle';
import PT from 'prop-types';
var bool = PT.bool,
  node = PT.node,
  object = PT.object,
  string = PT.string;
var defaults = {
  children: null,
  className: "",
  fixed: false,
  hideTreeAtMobile: false,
  id: null,
  linkUrl: null,
  onDark: false,
  small: false,
  scrolled: false,
  treeOnly: false,
  wordmarkLink: null
};
var Header = function Header(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? defaults.children : _ref$children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults.className : _ref$className,
    _ref$hideTreeAtMobile = _ref.hideTreeAtMobile,
    hideTreeAtMobile = _ref$hideTreeAtMobile === void 0 ? defaults.hideTreeAtMobile : _ref$hideTreeAtMobile,
    _ref$fixed = _ref.fixed,
    fixed = _ref$fixed === void 0 ? defaults.fixed : _ref$fixed,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? defaults.id : _ref$id,
    _ref$linkUrl = _ref.linkUrl,
    linkUrl = _ref$linkUrl === void 0 ? defaults.linkUrl : _ref$linkUrl,
    _ref$onDark = _ref.onDark,
    onDark = _ref$onDark === void 0 ? defaults.onDark : _ref$onDark,
    _ref$scrolled = _ref.scrolled,
    scrolled = _ref$scrolled === void 0 ? defaults.scrolled : _ref$scrolled,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? defaults.small : _ref$small,
    _ref$treeOnly = _ref.treeOnly,
    treeOnly = _ref$treeOnly === void 0 ? defaults.treeOnly : _ref$treeOnly,
    wordmark = _ref.wordmark,
    _ref$wordmarkLink = _ref.wordmarkLink,
    wordmarkLink = _ref$wordmarkLink === void 0 ? defaults.wordmarkLink : _ref$wordmarkLink;
  if (linkUrl) {
    console.warn("LinkUrl is deprecated, use wordmarkLink instead");
  }
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollPosition = _useState2[0],
    setScrollPosition = _useState2[1];
  var handleScroll = function handleScroll() {
    var position = window.scrollY;
    setScrollPosition(position);
  };
  useEffect(function () {
    var throttledHandleScroll = throttle(handleScroll, 200);
    if (fixed && typeof window !== "undefined") {
      window.addEventListener("scroll", throttledHandleScroll, {
        passive: true
      });
      return function () {
        window.removeEventListener("scroll", throttledHandleScroll);
      };
    }
  }, [fixed]);
  var classes = classnames("c-els-header", className, {
    "c-els-header--hide-tree-at-mobile": hideTreeAtMobile,
    "c-els-header--fixed": fixed,
    "c-els-header--scrolled": scrolled || fixed && scrollPosition > 0,
    "c-els-header--small": small
  });
  var renderLogoAndWordmark = function renderLogoAndWordmark() {
    return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("div", {
      className: "c-els-header__logo-wrapper"
    }, /* @__PURE__ */React.createElement(Logo, {
      className: "c-els-header__logo",
      onDark: onDark,
      treeOnly: treeOnly
    })), /* @__PURE__ */React.createElement("div", {
      className: "c-els-header__wordmark-wrapper"
    }, wordmark));
  };
  return /* @__PURE__ */React.createElement("header", {
    id: id,
    className: classes,
    "data-testid": "header"
  }, /* @__PURE__ */React.createElement("div", {
    className: "c-els-header__branding"
  }, linkUrl && /* @__PURE__ */React.createElement("a", {
    href: linkUrl,
    className: "c-els-header__branding-link"
  }, renderLogoAndWordmark()), wordmarkLink && /* @__PURE__ */React.createElement(LinkElement, _objectSpread(_objectSpread({}, wordmarkLink), {}, {
    className: "c-els-header__branding-link",
    image: true
  }), renderLogoAndWordmark()), !wordmarkLink && !linkUrl && renderLogoAndWordmark()), children);
};
Header.displayName = "Header";
Header.propTypes = {
  /** Child flex containers for header center and right content */
  children: node,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string,
  /** Fix the header to the top of the screen on scroll */
  fixed: bool,
  /** Do not show the tree logo at mobile breakpoint to save space */
  hideTreeAtMobile: bool,
  /** ID for the Header */
  id: string,
  /** DEPRECATED: Optional href for logo/wordmark wrapper */
  linkUrl: string,
  /** Flag to add drop shadow when scrolling has taken place */
  scrolled: bool,
  /** Flag to keep header small at all breakpoints */
  small: bool,
  /** Use the tree of live without the Elsevier wordmark */
  treeOnly: bool,
  /** Markup containing the application wordmark */
  wordmark: node.isRequired,
  /** Markup containing the application wordmark */
  wordmarkLink: object,
  /** Dark mode is active */
  onDark: bool
};
Header.requiredProps = {
  wordmark: ValidPropTypes.NODE
};
Header.defaults = defaults;
var RawHeader = Header;
var Header$1 = makeErrorBoundComponent(RawHeader);
export { Header$1 as Header, RawHeader };
